module.exports = __webpack_public_path__ + "static/media/worship_map.7dfe472f.svg";